<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="login-template-root">
  <div class="image">
    <ng-content select="[image]"></ng-content>
  </div>
  <ng-content select="[message]"></ng-content>
  <ng-content select="[firstInput]"></ng-content>
  <ng-content select="[secondInput]"></ng-content>
  <div class="second-input-subscript">
    <ng-content select="[secondInputSubscript]"></ng-content>
  </div>
  <ng-content select="[recaptcha]"></ng-content>
  <ng-content select="[buttonSection]"></ng-content>
  <ng-content select="[bottom]"></ng-content>
</form>
